import React, { memo, forwardRef } from "react";
const SvgKappa = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        d="M18.901 9a1 1 0 01.76 1.65l-3.889 4.54 4.555 6.22A1 1 0 0119.52 23h-.26a1 1 0 01-.81-.412l-4.297-5.909-1.724 1.41v3.696a1.215 1.215 0 11-2.429 0v-11.57a1.215 1.215 0 112.43 0v2.416c0 .696-.018 1.375-.053 2.037-.035.662-.07 1.167-.105 1.515h.053c.156-.226.322-.453.496-.68.191-.243.366-.46.522-.652l4.663-5.498A1 1 0 0118.77 9h.132z"
      />
    </svg>
  );
});
SvgKappa.displayName = "SvgKappa";
const MemoForwardRef = memo(SvgKappa);
export default MemoForwardRef;
